import { Question } from 'services/campaign/types';

export const getDocumentTypesFromQuestions = (questions: Question[]) => {
  return questions.reduce((acc: string[], question) => {
    if (question.documentTypes) {
      acc.push(...question.documentTypes);
    }
    return acc;
  }, []);
};
